// import {IRteToken} from '@/interface';

const MAX_REQUEST_TIME = 5;

export async function tokenRetry<T>(request: (timeout: number) => Promise<T>): Promise<T> {
    let requestCount = 0;
    return new Promise(async (resolve, reject) => {
        async function requestWrapper() {
            try {
                requestCount++;
                const res = await request(requestCount * 2000);
                if (res) {
                    resolve(res);
                }
            } catch (error) {
                console.error('error: ', error);
                if (requestCount < MAX_REQUEST_TIME) {
                    requestWrapper && requestWrapper();
                } else {
                    reject(error);
                }
            }
        }
        requestWrapper();
    });
}
